orders-planner-dialog-line-menu(class="{show: isShow}")
  .orders-planner-dialog-line-menu.popper
    ul
      li(onClick="{onClickAddLine}")
        span
          i.feather.icon-plus
          | { opts.locale.add_line }
      li(if="{this.multiline}" onClick="{onClickRemoveLine}")
        span
          i.feather.icon-x
          | { opts.locale.remove_line }
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.line-menu');
